<template>
  <FormularioCadastro
    module-name="Contabilista"
    :is-loading="isLoading"
    :is-editing="isEditing"
    :entity-info="entityInfo"
    @submit="salvar"
    @cancelar="handleCancel"
    @show-notification="(p) => emit('show-notification', p)"
  >
    <template #acoes-header v-if="isEditing">
      <button type="button" class="btn-icon-minimalista me-3" @click="mostrarAuditoria = true" title="Ver Histórico de Alterações">
        <i class="bi bi-clock-history"></i>
      </button>
    </template>

    <div v-if="!podeEditar" class="alert alert-warning border-0 rounded-3 mb-4 d-flex align-items-center">
      <i class="bi bi-lock-fill fs-4 me-3 text-warning"></i>
      <div><strong>Modo de Leitura:</strong> O seu perfil não tem permissões para editar este registo.</div>
    </div>

    <!-- FRAME 1: Dados Principais -->
    <div class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center pointer" @click="toggleAccordion('principal')">
        <h5 class="mb-0"><i class="bi bi-person-badge me-2"></i>Dados Principais</h5>
        <i class="bi" :class="accordionState.principal ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>
      <div v-show="accordionState.principal" class="card-body">
        <div class="row g-3">
          <div class="col-md-6">
            <CampoInput id="nome" label="Nome" v-model="item.nome" maxlength="100" required :readonly="!podeEditar" />
          </div>
          <div class="col-md-3">
            <CampoInput id="cpf" label="CPF" v-model="item.cpf" maxlength="11" :readonly="!podeEditar" />
          </div>
          <div class="col-md-3">
            <CampoBuscaLista id="lstStatus" label="Status" v-model="item.lstStatus" tabela="Contabilista" required :disabled="!podeEditar" />
          </div>
          <div class="col-md-3">
            <CampoInput id="crcNumero" label="CRC (nº)" v-model="item.crcNumero" maxlength="15" :readonly="!podeEditar" />
          </div>
          <div class="col-md-2">
            <CampoInput id="crcUf" label="CRC (UF)" v-model="item.crcUf" maxlength="2" :readonly="!podeEditar" />
          </div>
          <div class="col-md-4">
            <CampoInput id="cnpjEscritorio" label="CNPJ do Escritório" v-model="item.cnpjEscritorio" maxlength="14" :readonly="!podeEditar" />
          </div>
        </div>
      </div>
    </div>

    <!-- FRAME 2: Endereço -->
    <div class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center pointer" @click="toggleAccordion('endereco')">
        <h5 class="mb-0"><i class="bi bi-geo-alt me-2"></i>Endereço</h5>
        <i class="bi" :class="accordionState.endereco ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>
      <div v-show="accordionState.endereco" class="card-body">
        <div class="row g-3">
          <div class="col-md-2">
            <CampoInput id="cep" label="CEP" v-model="item.cep" maxlength="8" :readonly="!podeEditar" />
          </div>
          <div class="col-md-6">
            <CampoInput id="logradouro" label="Logradouro" v-model="item.logradouro" maxlength="60" :readonly="!podeEditar" />
          </div>
          <div class="col-md-2">
            <CampoInput id="numero" label="Número" v-model="item.numero" maxlength="10" :readonly="!podeEditar" />
          </div>
          <div class="col-md-2">
            <CampoInput id="complemento" label="Complemento" v-model="item.complemento" maxlength="60" :readonly="!podeEditar" />
          </div>
          <div class="col-md-4">
            <CampoInput id="bairro" label="Bairro" v-model="item.bairro" maxlength="60" :readonly="!podeEditar" />
          </div>
          <div class="col-md-4">
            <CampoInput id="cidade" label="Cidade" v-model="item.cidade" maxlength="60" :readonly="!podeEditar" />
          </div>
          <div class="col-md-2">
            <CampoInput id="uf" label="UF" v-model="item.uf" maxlength="2" :readonly="!podeEditar" />
          </div>
          <div class="col-md-2">
            <CampoInput id="codigoMunicipioIbge" label="Cód. IBGE" v-model="item.codigoMunicipioIbge" maxlength="7" :readonly="!podeEditar" />
          </div>
        </div>
      </div>
    </div>

    <!-- FRAME 3: Contato -->
    <div class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center pointer" @click="toggleAccordion('contato')">
        <h5 class="mb-0"><i class="bi bi-telephone me-2"></i>Contato</h5>
        <i class="bi" :class="accordionState.contato ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>
      <div v-show="accordionState.contato" class="card-body">
        <div class="row g-3">
          <div class="col-md-3">
            <CampoInput id="telefone" label="Telefone" v-model="item.telefone" maxlength="15" :readonly="!podeEditar" />
          </div>
          <div class="col-md-3">
            <CampoInput id="fax" label="Fax" v-model="item.fax" maxlength="15" :readonly="!podeEditar" />
          </div>
          <div class="col-md-6">
            <CampoInput id="email" label="E-mail" v-model="item.email" maxlength="60" :readonly="!podeEditar" />
          </div>
        </div>
      </div>
    </div>
  </FormularioCadastro>

  <AuditLogViewer
    v-if="mostrarAuditoria"
    tabela="Contabilista"
    :chave-primaria="item.idContabilista"
    :titulo-registro="item.nome"
    :dicionarios="{ 'lstStatus': listas.status }"
    @fechar="mostrarAuditoria = false"
  />
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { useFormulario } from '@/composables/useFormulario'
import { useAuthStore } from '@/stores/auth'
import { useMetadataListasStore } from '@/stores/metadataListas'
import FormularioCadastro from '@/components/base/formulario/FormularioCadastro.vue'
import CampoInput from '@/components/base/campos/CampoInput.vue'
import CampoBuscaLista from '@/components/base/campos/CampoBuscaLista.vue'
import AuditLogViewer from '@/components/base/auditoria/AuditLogViewer.vue'

const props = defineProps({
  itemParaEditar: Object,
  modeloVazio: {
    type: Object,
    default: () => ({
      idContabilista: 0,
      idOrganizacao: null,
      nome: '',
      cpf: '',
      crcNumero: '',
      crcUf: '',
      cnpjEscritorio: '',
      cep: '',
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      codigoMunicipioIbge: '',
      uf: '',
      telefone: '',
      fax: '',
      email: '',
      lstStatus: 'ST1'
    })
  }
})
const emit = defineEmits(['itemAtualizado', 'cancelar', 'show-notification'])

const authStore = useAuthStore()
const metadataStore = useMetadataListasStore()

const podeEditar = computed(() =>
  authStore.isAdminInterno ||
  (authStore.permissoes && authStore.permissoes.includes('CONTABILISTA'))
)

const { item, isLoading, isEditing, entityInfo, submitForm, handleCancel } = useFormulario(props, emit)

const mostrarAuditoria = ref(false)
const listas = reactive({ status: [] })

const accordionState = reactive({ principal: true, endereco: true, contato: true })
const toggleAccordion = (key) => { accordionState[key] = !accordionState[key] }

const carregarListas = async () => {
  try {
    listas.status = await metadataStore.getListaLookup('ST', 'Cliente')
  } catch (e) {
    console.warn('Erro ao carregar listas auxiliares:', e)
  }
}

async function salvar () {
  if (!podeEditar.value) return

  const payload = {
    ...item.value,
    idOrganizacao: authStore.organizacaoAtiva
  }

  await submitForm('Contabilistas', 'idContabilista', payload)
}

onMounted(() => { carregarListas() })
</script>
